import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Navigate } from 'react-router-dom';
import { login } from '../Redux/Actions/AuthActions';
import './Login.css';
import logo from "../image/LOGOTASKOPOS.jpg";

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [matricule, setMatricule] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [localError, setLocalError] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const user = useSelector((state) => state.AuthReducer?.user);
  const reduxErrors = useSelector((state) => state.AuthReducer?.errors || []);

  // Si déjà connecté avec token valide, rediriger vers la page appropriée
  if (token && user) {
    if (user.role === 'admin' || user.role === 'useradmin') {
      return <Navigate to="/BrandStatsHub" replace />;
    } else if (user.role === 'userspintoss') {
      return <Navigate to="/AddRapportsSpintoss" replace />;
    } else if (user.role === 'userwellness') {
      return <Navigate to="/AddRapports" replace />;
    } else {
      return <Navigate to="/Valises" replace />;
    }
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setLocalError('');

    if (!matricule.trim() && !email.trim()) {
      setLocalError("Veuillez saisir votre matricule ou votre adresse email.");
      return;
    }

    if (!password) {
      setLocalError("Veuillez saisir votre mot de passe.");
      return;
    }

    setSubmitting(true);
    try {
      await dispatch(login({ email: email.trim(), password, matricule: matricule.trim() }, navigate));
    } catch (err) {
      setLocalError(err.message || "Erreur de connexion");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 register-background">
      <div className="register-container shadow rounded p-4 p-md-5 text-center" style={{ maxWidth: '420px', width: '90%', background: '#fff' }}>
        <div className="mb-3">
          <img src={logo} alt="TASKO POS" className="mb-2" style={{ width: '130px', objectFit: 'contain' }} />
          <h4 className="fw-bold text-dark mb-1">Connexion TASKO</h4>
          <p className="text-muted small">Accédez à votre espace de gestion</p>
        </div>

        {localError && <Alert variant="danger" className="py-2 small text-start">{localError}</Alert>}
        {reduxErrors.length > 0 && reduxErrors.map((err, idx) => (
          <Alert key={idx} variant="danger" className="py-2 small text-start">{err.msg || err}</Alert>
        ))}

        <Form onSubmit={handleLogin} className="text-start">
          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold text-dark">Matricule</Form.Label>
            <Form.Control
              onChange={(e) => { setMatricule(e.target.value); setLocalError(''); }}
              type="text"
              placeholder="votre matricule"
              value={matricule}
              className="input-field"
              autoFocus
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold text-dark">Ou Adresse Email</Form.Label>
            <Form.Control
              onChange={(e) => { setEmail(e.target.value); setLocalError(''); }}
              type="email"
              placeholder="votre email"
              value={email}
              className="input-field"
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="small fw-bold text-dark">Mot de passe</Form.Label>
            <Form.Control
              onChange={(e) => { setPassword(e.target.value); setLocalError(''); }}
              type="password"
              placeholder="Votre mot de passe"
              value={password}
              className="input-field"
            />
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="w-100 btn-submit py-2 fw-bold"
            disabled={submitting}
            style={{ minHeight: '46px' }}
          >
            {submitting ? "⏳ Connexion en cours..." : "Se connecter"}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default Login;
